import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const data = await adminLogin(form.email, form.password);
      localStorage.setItem('millennium_admin_token', data.token);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to sign in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black px-[1.5rem] py-[3rem] flex items-center justify-center">
      <form onSubmit={handleSubmit} className="w-full max-w-[460px] rounded-[18px] border border-[#262626] bg-[#111] p-[2rem] shadow-[0_30px_80px_rgba(0,0,0,0.4)]">
        <p className="text-[14px] font-semibold uppercase tracking-[0.16em] text-[#EEC24B]">Admin Access</p>
        <h1 className="mt-[0.5rem] text-[34px] font-bold text-white">Millennium Realty</h1>
        <p className="mt-[0.75rem] text-[16px] font-light text-[#BDBDBD]">
          Sign in to manage rental and property listing content.
        </p>

        <div className="mt-[1.5rem] flex flex-col gap-[1rem]">
          <input
            type="email"
            value={form.email}
            onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
            placeholder="Admin email"
            className="w-full rounded-lg border border-[#262626] bg-[#1A1A1A] px-[1rem] py-[0.9rem] text-white outline-none focus:border-[#EEC24B]"
          />
          <input
            type="password"
            value={form.password}
            onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))}
            placeholder="Password"
            className="w-full rounded-lg border border-[#262626] bg-[#1A1A1A] px-[1rem] py-[0.9rem] text-white outline-none focus:border-[#EEC24B]"
          />
        </div>

        {error && (
          <p className="mt-[1rem] rounded-lg border border-red-900/40 bg-red-950/30 px-[1rem] py-[0.85rem] text-[14px] text-red-200">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="mt-[1.5rem] w-full rounded-lg bg-[#EEC24B] px-[1rem] py-[0.95rem] text-[16px] font-semibold text-black transition-opacity duration-300 hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
